import React, {useEffect, useState} from 'react'

import {Col, Row, Button, ListGroup, ListGroupItem, Form} from 'react-bootstrap'
import {InputWithLabel} from '../Form/InputWithLabel'
import Icon from '../../component/Icon/Icon'
import Notify from '../../services/Notify'
import LoadingV2 from '../Loading/LoadingV2'
import ReactSwitch from "react-switch";

function TodoList({title, data = [], onSaveItem, getItems, showSwitch, valueKey = "value", inputType}) {

  const [newItem, setNewItem] = useState(null)
  const [items, setItems] = useState(data)

  useEffect(() => {
    getItems && getItems(items)
  }, [items])

  const addNewItem = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      itemAlreadyExists({newItem})

      onSaveItem && await onSaveItem(newItem)

      setItems([...items])
      const newItemsSchema = {[valueKey]: newItem}
      if (showSwitch) {
        newItemsSchema.active = false
      }
      setItems([...items, newItemsSchema])
      setNewItem('')

      Notify.success('Item adicionado com sucesso')
    } catch (error) {
      Notify.error('Erro ao adicionar seu item', error)
    }
  }

  const updateItem = ({currentValue, editedValue}) => {
    const itemsUpdated = items.map(x => {
      if (x[valueKey] === currentValue) {
        x[valueKey] = editedValue
      }
      return x
    })
    setItems(itemsUpdated)
  }
  const updateActiveItem = (index, editedActive) => {
    const itemsUpdated = items.map((x, i) => {
      if (i === index) {
        x.active = editedActive
      }
      return x
    })
    setItems(itemsUpdated)
  }

  const itemAlreadyExists = ({currentValue, editedValue, newItem}) => {
    if (currentValue && editedValue && currentValue === editedValue) {
      return;
    }
    const itemsWithSameValue = items.filter(x => x[valueKey] === (editedValue || newItem))

    if (itemsWithSameValue.length > 0) {
      throw new Error('Este item já existe')
    }
  }

  const ListItem = ({text, index}) => {
    const [content, setContent] = useState({currentValue: text, editedValue: text})
    const [isEditing, setIsEditing] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const saveItem = async ({currentValue, editedValue}) => {
      try {
        setIsLoading(true)

        itemAlreadyExists({currentValue, editedValue})

        onSaveItem && await onSaveItem(editedValue)

        setContent({...content, currentValue: editedValue})
        updateItem(content)

        Notify.success('Item salvo com sucesso')
      } catch (error) {
        Notify.error('Erro ao salvar seu item', error)
        setContent({...content, editedValue: currentValue})
      } finally {
        setIsLoading(false)
      }
    }

    const onDeleteItem = (itemValue) => {
      const filteredItems = items.filter(x => x[valueKey] !== itemValue)
      setItems(filteredItems)
      Notify.success('Item deletado com sucesso')
    }

    return (
      <ListGroupItem>
        <Form>
          <Row className="align-items-center flex-nowrap justify-content-between">
            <Col className="ml-3 w-75">
              <input
                className="form-control"
                disabled={!isEditing}
                required="required"
                value={!isEditing ? content.currentValue : content.editedValue}
                onChange={e => setContent({...content, editedValue: e.target.value})}/>
            </Col>
            <Col className="ml-2 mr-3 d-flex">
              <LoadingV2 isLoading={isLoading}>
                <Button bsStyle="secondary" onClick={() => {
                  setIsEditing(!isEditing)
                  isEditing && saveItem(content)
                }}>
                  <Icon icon={!isEditing ? 'pencil-square-o' : 'check'}/>
                </Button>
              </LoadingV2>
              <Button bsStyle="danger" onClick={() => onDeleteItem(content.currentValue)}>
                <Icon icon="trash-o"/>
              </Button>
              {showSwitch && <ReactSwitch className="align-items-center"
                                          onChange={(checked, event, id) => {
                                            updateActiveItem(index, checked)
                                          }}
                                          checked={items[index].active}
              />}
            </Col>
          </Row>
        </Form>
      </ListGroupItem>
    )
  }

  const renderItems = () => {
    return items && items.map((x, i) => {
      return x[valueKey] && <ListItem text={x[valueKey]} key={i} index={i}/>
    })
  }

  return (
    <div>
      <Form onSubmit={addNewItem}>
        <Row className="align-items-center">
          <Col md={6}>
            <InputWithLabel required="required" inputType={inputType} label={title} value={newItem}
                            onChangeText={setNewItem}/>
          </Col>
          <Col md={6} className="mt-4">
            <Button bsStyle="primary" type="submit">Adicionar</Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col md={6} className="mt-3">
          <ListGroup style={styles.listGroupContainer}>
            {
              items.length > 0 ? renderItems() : <h5>Sem itens adicionados.</h5>
            }
          </ListGroup>
        </Col>
      </Row>
    </div>
  )
}

const styles = {
  listGroupContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '175px',
    width: '100%'
  },
}

export default TodoList



// WEBPACK FOOTER //
// ./src/component/List/TodoList.js